// src/poker/PokerLobby.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import pokerSocket, { ensurePokerAuthAndConnect } from '../pokerSocket';
import { usePoker } from './context/PokerContext';
import './Poker.css';

// === события (если на бэке другие — поменяй тут и в PokerTable.jsx) ===
const EV = {
  LOBBY_JOIN:       'lobby:join',
  LOBBY_REQUEST:    'lobby:requestTables',
  TABLE_JOIN:     'table:join',
  LOBBY_SNAPSHOT:   'lobby:snapshot',
  LOBBY_TABLE_UPD:  'lobby:tableUpdated',
};

const ENABLE_LOBBY_MOCK = false;

export default function PokerLobby() {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
const { lobbyTables, setLobbyTables, setTableState } = usePoker();

  const [tab, setTab] = useState('6'); // "6" или "9"
  const username = localStorage.getItem('username');
  const [joiningId, setJoiningId] = useState(null);



  // 1) коннектимся и подписываемся на пуши лобби
useEffect(() => {
  let alive = true; // чтобы не писать в стейт после анмаунта

  // то, что должно случиться ПОСЛЕ подключения
  const sendLobbyHandshake = () => {
    if (!alive) return;

    // вступаем в лобби
    pokerSocket.emit(EV.LOBBY_JOIN);

    // разовый снимок по ACK
    pokerSocket.emit(EV.LOBBY_REQUEST, (ackList) => {
      if (!alive) return;
      setLobbyTables(Array.isArray(ackList) ? ackList : []);
    });
  };

  // гарантируем наличие токена и попытку коннекта
  ensurePokerAuthAndConnect();

  // если уже подключены — шлём сразу
  if (pokerSocket.connected) {
    sendLobbyHandshake();
  } else {
    // иначе дождёмся события connect ОДИН раз
    pokerSocket.once('connect', sendLobbyHandshake);
  }

  // пуш: таблица обновилась (playersCount и т.п.)
  const onUpsert = (patch) => {
    if (!patch || !patch.id) return;
    setLobbyTables(prev => {
      const i = prev.findIndex(t => t.id === patch.id);
      if (i === -1) return [...prev, patch];
      const copy = prev.slice();
      copy[i] = { ...copy[i], ...patch };
      return copy;
    });
  };

  // снапшот (если бэк его когда-нибудь начнёт слать)
  const onSnapshot = (list) => {
    if (!alive) return;
    setLobbyTables(Array.isArray(list) ? list : []);
  };

  pokerSocket.on(EV.LOBBY_TABLE_UPD, onUpsert);
  pokerSocket.on(EV.LOBBY_SNAPSHOT, onSnapshot);

  return () => {
    alive = false;
    pokerSocket.off(EV.LOBBY_TABLE_UPD, onUpsert);
    pokerSocket.off(EV.LOBBY_SNAPSHOT, onSnapshot);
    pokerSocket.off('connect', sendLobbyHandshake); // на всякий случай
  };
}, [setLobbyTables]);

// useEffect(() => {
//   ensurePokerAuthAndConnect();

//   // вступаем в лобби
//   pokerSocket.emit(EV.LOBBY_JOIN);

//   // разовый снимок по ACK
//   pokerSocket.emit(EV.LOBBY_REQUEST, (ackList) => {
//     setLobbyTables(Array.isArray(ackList) ? ackList : []);
//   });

//   // пуш: таблица обновилась (playersCount и т.п.)
//   const onUpsert = (patch) => {
//     if (!patch || !patch.id) return;
//     setLobbyTables(prev => {
//       const i = prev.findIndex(t => t.id === patch.id);
//       if (i === -1) return [...prev, patch];
//       const copy = prev.slice();
//       copy[i] = { ...copy[i], ...patch };
//       return copy;
//     });
//   };

//   // (если когда-то начнёшь рассылать 'lobby:snapshot')
//   const onSnapshot = (list) => setLobbyTables(Array.isArray(list) ? list : []);

//   pokerSocket.on(EV.LOBBY_TABLE_UPD, onUpsert);
//   pokerSocket.on(EV.LOBBY_SNAPSHOT, onSnapshot);

//   return () => {
//     pokerSocket.off(EV.LOBBY_TABLE_UPD, onUpsert);
//     pokerSocket.off(EV.LOBBY_SNAPSHOT, onSnapshot);
//   };
// }, [setLobbyTables]);





// 🔻 МОК-эффект: подбрасываем тестовые столы, если сокет/сервер не ответил
useEffect(() => {
  const t = setTimeout(() => {
   if (ENABLE_LOBBY_MOCK && (!Array.isArray(lobbyTables) || lobbyTables.length === 0)) {
      setLobbyTables([
        {
          id: 101,
          name: '$0.5/$1 6-max #101',
          seatsMax: 6,
          playersCount: 0,
          blinds: { sb: 0.5, bb: 1 },
          minBuyIn: 50,
          maxBuyIn: 200,
          __mock: true,            // 👈 метка «это мок»
        },
        {
          id: 201,
          name: '$1/$2 9-max #201',
          seatsMax: 9,
          playersCount: 2,
          blinds: { sb: 1, bb: 2 },
          minBuyIn: 100,
          maxBuyIn: 400,
          __mock: true,            // 👈 метка «это мок»
        },
      ]);
    }
  }, 600);
  return () => clearTimeout(t);
}, [lobbyTables, setLobbyTables]);


  const list = useMemo(
    () => lobbyTables
      .filter(t => String(t?.seatsMax) === tab)
      .sort((a, b) => (a.blinds?.bb || 0) - (b.blinds?.bb || 0)),
    [lobbyTables, tab]
  );



  const join = (table) => {
  if (!username) { navigate('/login'); return; }
  if (joiningId !== null) return;      // уже идём за другой стол — игнор клика
  ensurePokerAuthAndConnect();

  // Сбросим возможный старый снимок, чтобы не мигало
  setTableState(null);

  // Отмечаем ровно тот стол, куда «заходим»
  setJoiningId(table.id);

  // Простой таймер-костыль на 2 сек
  setTimeout(() => {
    navigate(`/poker/table/${table.id}`);
    setJoiningId(null); // опционально: если вдруг не уйдём со страницы
  }, 2000);
};


// const join = (table) => {
//   if (!username) { navigate('/login'); return; }
//   ensurePokerAuthAndConnect();

//   // Сбросим возможный старый снимок, чтобы не мигало при заходе.
//   setTableState(null);

//   // Идём на экран стола. Там появятся кнопки "Сесть" на свободных местах,
//   // а бай-ин спросит handleJoinSeat() в PokerTable.jsx.
//   // navigate(`/poker/table/${table.id}`);
// //   setTimeout(() => {
// //   navigate(`/poker/table/${table.id}`);
// // }, 2000);

// if (!username) { navigate('/login'); return; }
// if (isJoining) return;            // защита от даблклика
// setIsJoining(true);

// setTableState(null);
// setTimeout(() => {
//   navigate(`/poker/table/${table.id}`);
//   setIsJoining(false);            // разблокируем после перехода
// }, 2000);

// };


// const join = (table) => {
//   if (!username) { navigate('/login'); return; }

//   // Берём min/max из сервера, иначе фолбэк 50–100BB
//   const bb  = Number(table?.blinds?.bb || 0);
//   const min = Number(table?.minBuyIn ?? (bb ? bb * 50 : 0));
//   const max = Number(table?.maxBuyIn ?? (bb ? bb * 100 : min)); // 👈 100BB

//   let buyIn = Number(prompt(`Сколько внести? (мин $${min}${max ? `, макс $${max}` : ''})`, String(min)));
//   if (!Number.isFinite(buyIn) || buyIn < min) { alert('Недопустимая сумма.'); return; }
//   if (max && buyIn > max) {
//    // можно сразу предупредить и НЕ слать на сервер
//    alert(`Максимальный бай-ин для этого стола: $${max}. Введите не больше.`);
//    return;
//  }

//   // на всякий случай убедимся, что авторизация в сокете проставлена
//   ensurePokerAuthAndConnect();

//   pokerSocket.emit(EV.TABLE_JOIN, { tableId: table.id, buyIn }, (ack) => {
//     if (!ack || !ack.ok) {
//     alert(ack?.message || 'Не удалось присоединиться');
//     return;
//   }
//     // Можешь сразу положить снапшот в контекст — стол откроется мгновенно.
//     setTableState(ack.snapshot);
//     navigate(`/poker/table/${table.id}`);
//   });
// };


  return (
    <div className="poker-lobby">
      <div className="poker-lobby__header">
  <div>
    <h1 className="poker-lobby__title">
      {translate('poker.title')} <span>{translate('poker.cashTables')}</span>
    </h1>
    <p className="poker-lobby__subtitle">
      {translate('poker.subtitle')}
    </p>
  </div>

  {/* если вернёшь табы — они будут аккуратно справа */}
  {/* <div className="poker-tabs"> ... </div> */}
</div>


    {list.length === 0 ? (
  <div className="poker-lobby__empty">
    {translate('poker.noTables', { max: tab })}
  </div>
) : (
  <div className="poker-tablelist">
    <table className="poker-lobby__table">
      <thead>
        <tr>
          <th className="col-name">{translate('poker.columns.table')}</th>
          <th className="col-blinds">{translate('poker.columns.blinds')}</th>
          <th className="col-players">{translate('poker.columns.players')}</th>
          <th className="col-buyin">{translate('poker.columns.buyIn')}</th>
          <th className="col-act"></th>
        </tr>
      </thead>
      <tbody>
        {list.map((tbl) => {
          const players = Number(tbl.playersCount || 0);
          const seats   = Number(tbl.seatsMax || 0);
          const sb = tbl?.blinds?.sb ?? 0;
          const bb = tbl?.blinds?.bb ?? 0;
          const min = tbl?.minBuyIn ?? (bb ? bb * 50 : 0);
          const max = tbl?.maxBuyIn ?? (bb ? bb * 100 : 0);
          const full = players >= seats;

          return (
            <tr key={tbl.id}>
              <td className="col-name">
                {tbl.name || `$${sb} / $${bb} — ${seats}-max`}
              </td>
              <td className="col-blinds">
                ${sb} / ${bb}
              </td>
              <td className="col-players">
                <span className={`pill ${full ? 'is-full' : ''}`}>
                  {players} / {seats}
                </span>
              </td>
              <td className="col-buyin">
                ${min}{max ? ` – $${max}` : ''}
              </td>
              <td className="col-act">
                {/* <button
                  className="poker-btn"
                  disabled={full}
                  onClick={() => join(tbl)}
                  type="button"
                >
                  {full ? 'Полон' : 'Сесть'}
                </button> */}
                {/* <button
                  className="poker-btn"
                  disabled={full || isJoining}
                  onClick={() => join(tbl)}
                  type="button"
                >
                  {full ? 'Полон' : (isJoining ? 'Заходим…' : 'Сесть')}
                </button> */}
                <button
                  className="poker-btn"
                  disabled={full || joiningId === tbl.id}
                  onClick={() => join(tbl)}
                  type="button"
                >
                  {full
                    ? translate('poker.full')
                    : joiningId === tbl.id
                      ? translate('poker.joining')
                      : translate('poker.sit')}
                </button>

              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
)}

    </div>
  );
}
